import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getServiceTypes, getBranchs, getSegments } from '../../../utils/request'
import { addFilters, removeFilter } from '../../../store/actions/provider'

function FilterGroup({ title, items, selected, type, onToggle }) {
  return (
    <fieldset className='cp-filter-group'>
      <legend>{title}</legend>
      <div className='cp-filter-options'>
        {items.map(c => {
          const id = `filtro-${type}-${c.id}`
          return (
            <label key={c.id} htmlFor={id} className='cp-filter-option'>
              <input
                type='checkbox'
                id={id}
                checked={!!selected.find(s => s.id === c.id)}
                onChange={e => onToggle(c, e.target.checked, type)}
              />
              <span>{c.description}</span>
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}

export default function Filter() {
  const dispatch = useDispatch()
  const { provider } = useSelector(state => state)
  const { serviceTypes, branchs, segments, filters } = provider

  useEffect(() => {
    dispatch([getServiceTypes(), getSegments(), getBranchs()])
  }, [dispatch])

  const handleCheckBoxes = (object, checked, type) => {
    if (checked) {
      dispatch(addFilters(object, type, filters))
    }
    else {
      dispatch(removeFilter(object, type, filters))
    }
  }

  return (
    <div className='cp-filters'>
      <FilterGroup
        title='Veículos'
        type='segments'
        items={segments.filter(c => c.description !== 'Outros')}
        selected={filters.segments}
        onToggle={handleCheckBoxes}
      />
      <FilterGroup
        title='Ramo de atuação'
        type='branchs'
        items={branchs}
        selected={filters.branchs}
        onToggle={handleCheckBoxes}
      />
      <FilterGroup
        title='Serviços'
        type='services'
        items={serviceTypes.filter(s => s.description !== 'Autopeças')}
        selected={filters.services}
        onToggle={handleCheckBoxes}
      />
    </div>
  )
}
